import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 79" {...props}><path fill="currentColor" stroke="currentColor" d="M64.7 2.8c3.2-3.1 8.4-3.1 11.6 0l61.8 61.8c7.5 7.4-4.1 19.1-11.6 11.6l-56-56-56 56C7 83.7-4.6 72 2.9 64.5L64.7 2.8z" /></svg>);